const skills = {
    1: [
      {
        title: "HTML",
        level: 6,
      },
      {
        title: "CSS",
        level: 5,
      },
      {
        title: "React JS",
        level: 3,
      },
      {
        title: "JavaScript",
        level: 4,
      },
    ],
    2: [
      {
        title: "Python",
        level: 5,
      },
      {
        title: "Git",
        level: 3,
      },
      {
        title: "java",
        level: 4,
      },
      {
        title: "SQL",
        level: 2,
      },
      {
        title: "C++",
        level: 5,
      },
    ],
  };
  
  export default skills;
  